import { axiosInstance } from '@/http-common'

export async function getAssetSchemes(params?: {
  skip?: number
  take?: number
  searchValue?: string
}): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/asset-schemes', { params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getAssetScheme(id: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/asset-schemes/${id}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
